import styled from 'styled-components';

const StyledMenuSolutions = styled.div`
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  height: 100vh;
  padding-top: 150px;
  z-index: 3;
  opacity: 0;
  transition: opacity .5s ease-out;
  background-color: #fff;
  pointer-events: none;
  overflow: hidden;
  &.show{
    opacity: 1;
    pointer-events: all;
  }
  .wrapper--flex{
    position: relative;
    display: flex;
    height: 100%;
    flex-flow: row wrap;
    overflow: scroll;
  }
  .wrapper--flex .col {
    position: relative;
    flex: 1 1 50%;
    max-width: 50%;
  }
  .wrapper--flex .col.col--cases{
    flex: 1 1 33%;
    max-width: 33%;
  }
  .wrapper--flex .col.col--cases p {
    margin-bottom: 40px;
  }
  .wrapper--flex .col .intro--menu {
    margin-bottom: 40px;
    color: #4D4D4D;
  }
  .wrapper--flex .col .cta--primary {
    padding-bottom: 50px;
  }
  .wrapper--flex .col--image{
    display: flex;
    align-items: flex-end;
  }
  .wrapper--flex .col--image img{
    position: absolute;
    width: 100%;
    top: 0;
    right: 0%;
    opacity: 0;
    transition: opacity .5s ease-out;
  }
  .wrapper--flex .col h6{
    margin-bottom: 40px;
    cursor: pointer;
  }
  @media screen and (min-width: 1440px){
    .wrapper--flex{
      padding: 0 0 0 175px;
    }
  }
  @media screen and (max-width: 1439px) and (min-width: 1024px){
    .wrapper--flex{
      padding: 0 0 0 121px;
    }
    
  }
  @media screen and (max-width: 1023px){
    position: relative;
    height: auto;
    padding-top: 64px;
    .row--mobile{
      padding: 0 40px;
    }
    .tb--col{
      flex: 1 1 50%;
    }
    .wrapper--flex .tb--col p {
      font-size: 22.5px;
      line-height: 110%;
      font-weight: 400;
      padding-bottom: 16px;
    }
    .submenu--type{
      margin-top: 24px;
    }
  }
  @media screen and (max-width: 767px){
    .row--mobile{
      display: none;
    }
    .row--mobile.submenu--type{
      display: block;
      padding: 0 24px;
    }
    .tb--col{
      flex: 1 1 100%;
    }
    padding-top: 0px;
  }
  h6{
    opacity: 0;
    transition: all .15s ease-out ;
  }
  &.show h6{
    opacity: 1;
  }
  &.show .wrapper--flex .col--image img{
    opacity: 1;
    transition-delay: .25s;
  }
  
`;

export {
  StyledMenuSolutions,
};

